/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Icon, Dropdown, Menu, Button, Tooltip } from '@tinper/next-ui';
import './DataTableOperations.less';

function Operations (props) {
  const { operationItems: operationItemsProp, operationItemsMaxCount, record, index, operationType, rowKey, operationClick, fieldid, foldStatus, setFoldStatus, className = "", style = {} } = props;
  const operationItems = typeof operationItemsProp === 'function' ? operationItemsProp(record) : operationItemsProp;

  const operationItemsInline = Array.isArray(operationItems) ? operationItems.slice(0, operationItemsMaxCount) : operationItems;
  const isMoreMaxCount = operationItems.length > operationItemsMaxCount;
  const getMenusItems = (items) => {
    return items.map((item, index) => {
      return {
        key: item.key,
        label: item.text,
        onClick: ({ domEvent }) => {
          domEvent.stopPropagation();
          operationClick(record, item, domEvent, props.index)
        }
      }
    })
  }
  const otherOperationItems = operationItems.slice(operationItemsMaxCount);
  const menusItems = getMenusItems(otherOperationItems);
  const menusItemsAll = getMenusItems(operationItems);

  const menus = (<Menu items={menusItems} fieldid={`${fieldid}_operations_dropdown_menu`}></Menu>);
  const menusAll = (<Menu items={menusItemsAll} fieldid={`${fieldid}_operations_dropdown_menu`}></Menu>);

  const recordKey = record && record[rowKey];
  const changeStatus = (record, e) => {
    e.stopPropagation()
    setFoldStatus && setFoldStatus()
  }

  console.log(foldStatus, 'foldStatus')
  return (<div className={`astableOperation-opt-btns astableOperation ${className}`} style={style}>
    {
      !foldStatus
        ? <div style={{ display: 'inline-block' }}>
          {
            operationItemsInline.map(item => {
              return <Button
                type={operationType}
                size='sm'
                colors={operationType === 'link' ? "" : 'dark'}
                style={{ marginRight: '5px' }}
                onClick={(e) => { e.stopPropagation(); operationClick(record, item, e, index) }}
                fieldid={`${fieldid}_operations_item_${item.key}`}
                {...(item.otherProps || {})}>
                {item.text}

              </Button>
            })
          }
        </div>
        : null
    }

    {isMoreMaxCount || foldStatus
      ? <Dropdown overlay={!foldStatus ? menus : menusAll} placement={foldStatus ? "bottomRight" : "bottomLeft"} fieldid={`${fieldid}_operations_dropdown`}>
        {
          foldStatus
            ? <Button
              size='sm'
              className="as-dataTable-operation-btn"
              colors= {foldStatus ? "light" : "dark" }
              style={{ marginRight: '8px' }}
              icon={<Icon type='uf-arrow-down'/>}
              onClick={(e) => { e.stopPropagation() }}
              fieldid={`${fieldid}_operations_dropdownbtn`}
            />
            : <Button
              size='sm'
              colors= { "dark" }
              style={{ marginRight: '8px' }}
              fieldid={`${fieldid}_operations_dropdownbtn`}
            >更多 <Icon type='uf-arrow-down'/></Button>
        }
      </Dropdown>
      : null }
    {
      operationItems.length > operationItemsMaxCount
        ? <Tooltip arrowPointAtCenter placement="top" overlay={<span>{foldStatus ? "展开为悬停按钮" : "收起为常驻按钮"}</span>}><Button
          size='sm'
          className={foldStatus ? "as-dataTable-operation-btn" : ""}
          colors={foldStatus ? "light" : "dark" }
          icon={<Icon type={!foldStatus ? 'uf-youjiantou_shuang' : 'uf-daoshouye'}/>}
          onClick={changeStatus.bind(this, recordKey)}
          fieldid={`${fieldid}_operations_maxcountbtn`}
        >
        </Button></Tooltip>
        : null
    }

  </div>);
}

export default Operations;
